// extracted by mini-css-extract-plugin
export default {"container":"Section_container__tAten","title":"Section_title__0jAcF"};